
const adapter_Map = {
    default: {
        h5: 375,
        pad: 768,
        phone: 900,
    },
};

export const adapter = (set) => {
    return {
        adapter: adapter_Map.default,
        setAdapter: (next) => {
            set((state) => ({
                adapter: next,
            }));
        },
    };
};
